<template>
	<div class="main-wrapper">
		<!---Navigation-->
		<Navbar :topbarColor="topbarColor" width="295px" logo="/logo.png" :title="logotitle" />
		<!---Sidebar <SideBar parent=".main-wrapper" :sidebarLinks="sidebarLinks"/> -->
		
		<!---Page Container-->
		<div class="main-container-fluid" style="margin-left:0px;">
		
		<router-view></router-view>
		
	<vs-row style="justify-content: flex-end;">
        <vs-col vs-lg="3" vs-xs="12">
            <vs-card style="background:rgb(41, 98, 255);
    color: #fff;
    font-size: 16px;">
                <img width="100px" src="/logo_2.png" style="    margin-bottom: 10px;"/>
            	<div>работает на мощностях acmee</div>
			</vs-card>
        </vs-col>
    </vs-row> 
		</div>	
	</div>
</template>

<script>
 
import Navbar from '@/layout/full/header/Navbar.vue';
import SideBar from '@/layout/full/sidebar/SideBar.vue';
import sidebarLinks from '@/layout/full/sidebar/sidebarlinks.js';

export default {
name: "MainContainer",
components: {
Navbar,
SideBar

},
data:() => ({
	topbarColor: "#2962ff",
	logotitle: '',
	sidebarLinks: sidebarLinks,
}),
methods: {
	
},



}  	
</script>
